<template>
  <div v-if="song && songPositions && isHasStatistics(typeId)">
    <p class="song-info__list-name">{{name}}</p>
    <div class="song-info__basic-info">
      <InfoBlock
        :name="showInfoIfNotOnList(song.dateOfDebutOnList)"
        :value="song.dateOfDebutOnList"
      />
      <InfoBlock name="czas pobytu na liście" :value="song.weeksOnList" v-if="song.weeksOnList" />
      <InfoBlock
        name="miejsce debiutu w notowaniu"
        :value="song.debutPosition"
        v-if="song.debutPosition"
      />
      <InfoBlock
        name="miejsce w ostatnim notowaniu"
        :value="song.positionOnLastList"
        v-if="song.positionOnLastList"
      />
    </div>
    <div class="song-info__content" v-if="songPositions.length > 0">
      <div class="song-info__first-row">
        <div class="song-info__first-row-one">notowanie</div>
        <div class="song-info__first-row-two">pozycja na liście</div>
        <div class="song-info__first-row-three">trend</div>
      </div>
      <div class="song-info__table-little" v-for="(item, index) in songPositions" :key="index">
        <div
          class="song-info__table-note"
          @click="()=>{goToList(parseInt(item.number))}"
          v-on:keyup.enter="()=>{goToList(parseInt(item.number))}"
          tabindex="0"
          :aria-label="'Notowanie numer'+item.number"
        >{{item.number}}</div>
        <div
          class="song-info__table-position"
          tabindex="0"
          :aria-label="'Pozycja na liście'+item.position"
        >{{item.position}}</div>
        <div class="song-info__table-trend">
          <div class="song-info__symbol" tabindex="0" :aria-label="'Zmiana'+item.trend">
            <p>{{ item.trend }}</p>
            <div class="song-info__symbol-up" v-if="parseInt(item.trend) > 0"></div>
            <div class="song-info__symbol-zero" v-if="parseInt(item.trend) === 0"></div>
            <div class="song-info__symbol-down" v-if="parseInt(item.trend) < 0"></div>
          </div>
        </div>
      </div>
    </div>
  
  </div>
   
</template>
<script>
import InfoBlock from "@/ui/InfoBlock.vue";
import link from "@/scripts/host.js";

export default {
  data() {
    return {
      song: null,
      songPositions: null
    };
  },
  props: ["name", "typeId","resultsInfo"],
  computed: {
    changeRoute(){
        return this.$route.params.id
    },
    paramethers() {
      return this.$route.path;
    }
  },
  components: {
    InfoBlock
  },
  methods: {
    getStatistics(listTypeId) {
      this.axios
        .get(
          `${link.hostLink}Song/GetStats?songId=${this.$route.params.id}&listTypeId=${listTypeId}`
        )
        .then(response => {
          this.song = response.data;
        });
    },
    showInfoIfNotOnList(value) {
      if (value) {
        return "data debiutu na liście";
      } else {
        return "Utwór nie był notowany";
      }
    },
    goToList(id) {
      if(!this.$route.path.includes(`/lp3/${id}`)){
        this.$router.push(`/lp3/${id}`)
      }
    },
    getSongPositions(listTypeId) {
      this.axios
        .get(
          `${link.hostLink}Song/GetResults?id=${this.$route.params.id}&listTypeId=${listTypeId}`
        )
        .then(response => {
          this.songPositions = response.data;
        });
    },
    isHasStatistics(typeId){
      return this.$props.resultsInfo[typeId-1].hasResults
    },
  },
  mounted() {
    this.getStatistics(this.$props.typeId);
    this.getSongPositions(this.$props.typeId);
  },
  watch: {
      changeRoute(){
          this.getStatistics(this.$props.typeId);
          this.getSongPositions(this.$props.typeId);
      }
  }
};
</script>

<style lang="scss" scoped>
.song-info {
  width: 100%;
    height: 100%;
    max-width: 1200px;
  display: flex;
  justify-content: center;
  border-radius: 5px;
  margin: 2rem auto;

  &__list-name {
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    margin: 2rem 0rem;
    font-size: 1.3rem;
    text-transform: uppercase;
    border-bottom: 3px solid #efeeee;
    padding-bottom: 1rem;
  }
  &__table {
    display: flex;
    width: 100%
  }
  &__left-column {
    width: 67%;
    background-color: #fefefe;
    padding: 3rem 1rem 3rem 1rem;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  &__top {
    display: flex;
    justify-content: space-between;
  }
  &__info-container {
    display: flex;
    flex-direction: column;
  }
  &__song-title {
    font-family: "Poppins", sans-serif;
    color: #0f1626;
    font-size: 1.3rem;
    font-weight: 700;
    padding-bottom: 0.5rem;
  }
  &__song-name {
    font-family: "Poppins", sans-serif;
    color: #0f1626;
    font-size: 1.3rem;
    padding-bottom: 0.5rem;
    cursor: pointer;
  }
  &__photo {
    width: 18.125rem;
    height: 10rem;
    border: 1px solid #e13368;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  &__basic-info {
    display: flex;
    justify-content: space-between;
    margin: 2rem 0;
  }
  &__first-row {
    display: flex;
    font-size: 0.7rem;
    font-family: "Poppins", sans-serif;
    text-transform: uppercase;
    color: #7e7e7e;
  }
  &__first-row-one {
    width: 8rem;
    display: flex;
    justify-content: center;
    padding: 0.5rem;
  }
  &__first-row-two {
    width: 17.4rem;
    display: flex;
    justify-content: center;
    padding: 0.5rem;
  }
  &__first-row-three {
    width: 21rem;
    display: flex;
    justify-content: center;
    padding: 0.5rem;
  }
  &__table-little {
    display: flex;
    font-size: 1rem;
    font-family: "Poppins", sans-serif;
    justify-content: space-around;
    margin-bottom: 0.2rem;
    flex-wrap: nowrap;
  }
  &__table-note {
    width: 8rem;
    display: flex;
    justify-content: center;
    padding: 0.5rem;
    border-radius: 5px;
    background-color: #efeeee;
    color: #c574e7;
    font-weight: 700;
    cursor: pointer;
  }
  &__table-position {
    width: 17.4rem;
    display: flex;
    justify-content: center;
    padding: 0.5rem;
    border-radius: 5px;
    background-color: #efeeee;
    font-weight: 700;
  }
  &__table-trend {
    width: 21rem;
    display: flex;
    justify-content: center;
    padding: 0.5rem;
    border-radius: 5px;
    background-color: #efeeee;
    font-weight: 700;
  }
  &__symbol {
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      width: 2rem;
      text-align: right;
    }
  }
  &__symbol-up {
    width: 0;
    height: 0;
    border-left: 0.5rem solid transparent;
    border-right: 0.5rem solid transparent;
    border-bottom: 0.7rem solid #4dc81d;
    margin-left: 0.3rem;
  }
  &__symbol-zero {
    width: 0.7rem;
    height: 0.7rem;
    background-color: #fbb101;
    border-radius: 100%;
    margin-left: 0.3rem;
  }
  &__symbol-down {
    width: 0;
    height: 0;
    border-left: 0.5rem solid transparent;
    border-right: 0.5rem solid transparent;
    border-top: 0.7rem solid #df2860;
    margin-left: 0.3rem;
  }
  &__right-column {
    width: 33%;
    background-color: #28233a;
    padding: 3rem 1rem 1rem 1rem;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  &__music-title {
    color: #d0d0e0;
    text-transform: uppercase;
    font-size: 1.2rem;
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    padding-bottom: 0.5rem;
    line-height: 1.3;
    margin-top: -0.25rem;
  }
  &__song {
    cursor: pointer;
    color: #d0d0e0;
    font-size: 0.75rem;
    font-family: "Poppins", sans-serif;
    padding-bottom: 1rem;
    display: flex;
    align-items: center;
    transition: color 0.5s;
  }
  &__song-dot {
    width: 0.4rem;
    height: 0.4rem;
    background-color: #d0d0e0;
    border-radius: 100%;
    margin-right: 1rem;
  }
  &__music {
    display: flex;
    margin-bottom: 2rem;
  }
  &__music-pink-square {
    width: 1rem;
    height: 1rem;
    background-color: #df2860;
    margin-right: 1rem;
  }
  &__song:hover {
    color: #8b8a9f;
  }
  &__song.active {
    color: #df2860;
  }
  .photoContentWithoutPhoto {
    background-image: url("/img/zaslepa.jpg") !important;
  }
}
</style>
